import * as React from 'react';
// @ts-ignore
import Dotdotdot from 'react-dotdotdot';
import './index.less';

interface DotDotDotProps {
  height: number;
  className?: string;
}
const DotDotDot: React.SFC<DotDotDotProps> = (props) => {
  const { height, children = '', className } = props;
  const title = typeof children === 'string' ? children : '';
  //  存在问题, 换行必须为中文字符
  return (
    <div className={`mpc-dot ${className}`} title={title}>
      <Dotdotdot clamp={height || 3}>
        {children}
      </Dotdotdot>
    </div>
  );
};

export default DotDotDot;
